export default "/images/vendor/flag-icon-css/flags/1x1/es-ca.svg?a03129ff81e9f5633e7501e84ad38e4d";